
export default {
  name: 'UserInfo',
  props: {
    user: Object,
  },
};
